'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an inspector button
 *
 * @class
 */

class InspectorCommonControlsButton extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
      <div class='editor__inspector__item__cc__button js-inspector__cc__button'>
        <div class='editor__inspector__item__cc__button__icon js-inspector__cc__button__icon'>
					<canvas class='editor__inspector__item__cc__button__icon__canvas js-inspector__cc__button__icon__canvas'/>
				</div>
        <div class='editor__inspector__item__cc__button__label js-inspector__cc__button__label'>
          <%- title %>
        </div>
      </div>
		`;

		super.render();

		/**
		* Click event
		*
		* @fires Inspector#_clicked
		*/

		$(this.$el).on('click', this._clicked);
	}

	/**
	* setLabel
	*
	* @param {string} value - the value that you want to set
	*/

	setLabel(value){
		$('.js-inspector_cc_button_label', this.$el).html(value);
	}

	tiltIcon() {
		$('.js-inspector__cc__button__icon__canvas', this.$el).addClass('editor__inspector__item__cc__button__icon__canvas--tilt');
	}

	selectBtn() {
		$('.js-inspector__cc__button__icon').removeClass('editor__inspector__item__cc__button__icon--selected');
		$('.js-inspector__cc__button__icon', this.$el).addClass('editor__inspector__item__cc__button__icon--selected');
	}

	drawColorIcon(colorList) {
		var canvas = $('.js-inspector__cc__button__icon__canvas', this.$el).get(0);
		var ctx = canvas.getContext("2d");

		if (colorList.length > 1) {
			var rectWidth = canvas.width/8;
			for (var i=0; i < 8; i++) {
				ctx.fillStyle = colorList[i%colorList.length];
				ctx.fillRect(rectWidth*i,0,rectWidth*i + rectWidth, canvas.height*2);
			}
		} else {
			ctx.fillStyle = colorList[0];
			ctx.fillRect(0, 0, canvas.width, canvas.height);
		}
	}

	drawSolidIcon(colorList) {
		var canvas = $('.js-inspector__cc__button__icon__canvas', this.$el).get(0);
		var ctx = canvas.getContext("2d");
		var rectWidth = canvas.width/8;
		for (var i=0; i < 8; i++) {
			ctx.fillStyle = colorList[i%colorList.length];
			ctx.fillRect(rectWidth*i,0,rectWidth*i + rectWidth, canvas.height*2);
		}
	}

	drawHoleIcon() {
		var canvas = $('.js-inspector__cc__button__icon__canvas', this.$el).get(0);
		var ctx = canvas.getContext("2d");
		var rectWidth = canvas.width/6;

		for (var i=0; i < 6; i++) {
			if (i%2) {
				ctx.fillStyle = "#aaaaaa";
			} else {
				ctx.fillStyle = "#cccccc";
			}
			ctx.fillRect(rectWidth*i,0,rectWidth*i + rectWidth, canvas.height*2);
		}
	}

	/**
     * @event Inspector#Cioui:Inspector:click
     * @property {String}Cioui:Inspector:click
     * @returns {Object} event - native click Event
     */

	_clicked(e){
		e.preventDefault();
		$(e.currentTarget).trigger('Cioui:Inspector:click', e);

		$('.js-inspector__cc__button__icon').removeClass('editor__inspector__item__cc__button__icon--selected');
		$(e.currentTarget).children('.js-inspector__cc__button__icon').addClass('editor__inspector__item__cc__button__icon--selected');
	}
}
module.exports = InspectorCommonControlsButton;
